<template>
    <div class="component-wrap tab-bar fx-around fx-row">
        <router-link class="tab-router fx-center-middle" to="/index">
            <span></span>
        </router-link>
        <!-- <router-link class="tab-router fx-center-middle" to="cinema">
            <span></span>
        </router-link> -->
        <router-link class="tab-router fx-center-middle" to="user">
            <span></span>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "tab-bar",
};
</script>

<style lang="scss">
.tab-bar {
	width: 100%;
	height: 50px;
	position: fixed;
	z-index: 10;
	bottom: 0;
	border-top: 1px solid #d8d8d8;
	background-color: #fff;
	.tab-router {
		width: 45px;
		text-align: center;
		span {
			display: block;
			width: 45px;
			height: 42px;
			background-size: 100%;
			background-repeat: no-repeat;
		}
	}
	:nth-child(1) {
		span {
			background-image: url("./icons/movie-icon.png");
		}
	}
	:nth-child(2) {
		span {
			background-image: url("./icons/user-icon.png");
		}
	}
	// :nth-child(3) {
	// 	span {
	// 		background-image: url("./icons/me.png");
	// 	}
	// }
	.tab-router.router-link-active:nth-child(1) {
		span {
			background-image: url("./icons/movie_active-icon.png");
		}
	}
	.tab-router.router-link-active:nth-child(2) {
		span {
			background-image: url("./icons/user_active-icon.png");
		}
	}
	// .tab-router.router-link-active:nth-child(3) {
	// 	span {
	// 		background-image: url("./icons/me_active.png");
	// 	}
	// }
}
</style>
